import { CSSVariablesResolver } from '@mantine/core';

const resolver: CSSVariablesResolver = () => ({
  variables: {
    '--mobile-bottom-button-height': '80px',
  },
  light: {},
  dark: {},
});

export { resolver };
